import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/home/index.vue'

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: {
        title: 'KOMA'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const removeTagList = []
  document?.head?.childNodes?.forEach((item) => {
    if (item.tagName === 'TITLE') {
      item.innerText = to.meta.title
    }
    if (item.tagName === 'META' && ['keywords', 'description'].includes(item.name)) {
      removeTagList.push(item)
    }
  })
  // 删除原有keywords，description内容
  removeTagList.forEach((item) => {
    document.head.removeChild(item)
  })
  // 添加新的内容
  if (to.meta.keywords) {
    const meta1 = document.createElement('META')
    meta1.name = 'keywords'
    meta1.content = to.meta.keywords
    document.head.appendChild(meta1)
  }
  if (to.meta.description) {
    const meta2 = document.createElement('META')
    meta2.name = 'description'
    meta2.content = to.meta.description
    document.head.appendChild(meta2)
  }
  next()
})

export default router
